import { ScanMetadata } from '../../interfaces/scanMetadata';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';

export const getFilteredScansByInbodyType = (
  scansMetadata: ScanMetadata[],
  inbodyType: InbodyType | 'ALL' | undefined | null,
): ScanMetadata[] => {
  if (!inbodyType || inbodyType === 'ALL') {
    return scansMetadata;
  }
  return scansMetadata.filter((scan) => scan.inbodyType === inbodyType);
};
